// src/components/LevelMenu.js
import React from 'react';

/**
 * Konfigurasi statis untuk semua level yang tersedia di setiap mode permainan.
 * Memisahkan data dari logika tampilan adalah praktik yang baik.
 */
const LEVEL_CONFIG = {
    addition: [
        { id: 'beginner', name: 'Beginner', desc: '1 Digit + 1 Digit', stars: 1 },
        { id: 'amateur', name: 'Amateur', desc: '1D + 2D (Campuran)', stars: 2 },
        { id: 'pro', name: 'Pro', desc: '2 Digit + 2 Digit', stars: 3 },
    ],
    subtraction: [
        { id: 'beginner', name: 'Beginner', desc: '1 Digit - 1 Digit', stars: 1 },
        { id: 'amateur', name: 'Amateur', desc: '2D - 1D (Campuran)', stars: 2 },
        { id: 'pro', name: 'Pro', desc: '2 Digit - 2 Digit', stars: 3 },
    ],
    multiplication: [
        { id: 'beginner', name: 'Beginner', desc: '1D × 1D', stars: 1 },
        { id: 'amateur', name: 'Amateur', desc: '1D × 2D', stars: 2 },
        { id: 'pro', name: 'Pro', desc: '2D × 2D', stars: 3 },
    ],
    division: [
        { id: 'beginner', name: 'Beginner', desc: 'Hasil Bulat (Kecil)', stars: 1 },
        { id: 'amateur', name: 'Amateur', desc: 'Hasil Bulat (Besar)', stars: 2 },
        { id: 'pro', name: 'Pro', desc: 'Bulat / Desimal', stars: 3 },
    ],
};

/**
 * Objek untuk menerjemahkan ID mode menjadi nama yang lebih ramah pengguna.
 */
const MODE_NAMES = {
    addition: 'Penjumlahan',
    subtraction: 'Pengurangan',
    multiplication: 'Perkalian',
    division: 'Pembagian',
}

/**
 * Komponen LevelMenu menampilkan pilihan level kesulitan berdasarkan mode matematika yang dipilih.
 * @param {object} props - Properti komponen.
 * @param {string} props.mathMode - Mode matematika yang sedang aktif (misalnya, 'addition').
 * @param {function} props.onSelectLevel - Fungsi callback yang dipanggil saat level dipilih.
 * @param {function} props.onBack - Fungsi callback yang dipanggil saat tombol kembali diklik.
 */
function LevelMenu({ mathMode, onSelectLevel, onBack }) {
    // Mendapatkan daftar level yang sesuai dengan mode yang dipilih dari props.
    // Safeguard `|| []` untuk mencegah error jika mathMode tidak valid.
    const availableLevels = LEVEL_CONFIG[mathMode] || [];
    
    // Mendapatkan nama mode yang akan ditampilkan di subtitle.
    const modeName = MODE_NAMES[mathMode] || 'Tidak Diketahui';

    return (
        <div id="levelMenu" className="menu-screen" style={{ display: 'flex' }}>
            <div className="menu-container compact">
                <h1 className="menu-title">Pilih Level Kesulitan</h1>
                <p id="levelSubtitle" className="menu-subtitle">
                    Mode: {modeName}
                </p>
                <div className="menu-buttons" id="levelButtons">
                    {/* 
                      Render daftar tombol level secara dinamis menggunakan .map().
                      Setiap tombol memiliki properti `key` unik (penting untuk React).
                    */}
                    {availableLevels.map((level) => (
                        <button
                            key={level.id}
                            className={`menu-btn level-btn ${level.id}`}
                            onClick={() => onSelectLevel(level.id)}
                        >
                            <span className="level-icon">{'⭐'.repeat(level.stars)}</span>
                            <span className="level-name">{level.name}</span>
                            <span className="level-desc">{level.desc}</span>
                        </button>
                    ))}
                </div>
                <button className="back-btn" onClick={onBack}>
                    ← Kembali
                </button>
            </div>
        </div>
    );
}

export default LevelMenu;